module.exports = __webpack_public_path__ + "static/media/people (5).63662413.svg";